import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ownerAccountsBalanceRefresh } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
// import formatTotalBalance from "../../../utils/formatTotalBalance";
import {
  errorcode,
  GlobalConfiguration,
} from "../../../../utils/configurationProvider";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import CommonToast from "../../../_utils/CommonToast";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import ICONS from "../../../../assets/Icons";

function OwnerAccountConnectedBankCard({
  owner,
  ownerAccounts,
  setOwnerAccounts,
  ownerAccBalanceLoading,
  ownerAccBalanceError,
  updateTotalBalance,
  total_balance,
  connectedBankingOwnerAccounts,
  setConnectedBankingOwnerAccounts,
}) {
  const navigate = useNavigate();
  const [accId, setAccId] = useState("");
  const services = useSelector((state) => state.refreshToken.services);
  const [currentConnectedBal, setCurrentConnectedBal] = useState("");
  const [prevConnectedBal, setPrevConnectedBal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [refreshSuccess, setRefreshSuccess] = useState(false);
  const requiredServices =
    services?.includes("VAccountBalance") || services?.includes("Admin");
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  const dispatch = useDispatch();

  const handleRefresh = async (id) => {
    CommonToast({
      text: "Refreshing balance",
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
    });
    setRefreshSuccess(false);
    setIsLoading(true);
    try {
      let response = await dispatch(ownerAccountsBalanceRefresh(id));
      if (response?.payload?.status === true) {
        setRefreshSuccess(true);
        let updatedOwnersData = ownerAccounts?.map((item) => {
          if (
            response?.payload?.owner_accounts[0]?.owner_account_id === item?.id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response?.payload?.owner_accounts[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response?.payload?.owner_accounts[0]?.owner_account_balance,
              owner_account_balance_last_fetched_at:
                response.payload?.owner_accounts[0]
                  ?.owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });

        const updatedConnectedBankingData = connectedBankingOwnerAccounts?.map(
          (item) => {
            if (
              response?.payload?.owner_accounts[0]?.owner_account_id ===
              item?.id
            ) {
              return {
                ...item,
                owner_account_balance_last_fetched_at_in_words:
                  response?.payload?.owner_accounts[0]
                    ?.owner_account_balance_last_fetched_at_in_words,
                owner_account_balance:
                  response?.payload?.owner_accounts[0]?.owner_account_balance,
                owner_account_balance_last_fetched_at:
                  response.payload?.owner_accounts[0]
                    ?.owner_account_balance_last_fetched_at,
              };
            }
            return item;
          },
        );

        setOwnerAccounts(updatedOwnersData);
        setConnectedBankingOwnerAccounts(updatedConnectedBankingData);

        const prevBalance = connectedBankingOwnerAccounts?.find(
          (owner) => owner.id === id,
        )?.owner_account_balance;

        setPrevConnectedBal(prevBalance);

        const refreshedBalance = response?.payload.owner_accounts.find(
          (owner) => owner.owner_account_id === id,
        )?.owner_account_balance;

        setCurrentConnectedBal(refreshedBalance);

        const updatedConnectedBankingTotal =
          Number(total_balance) -
          Number(prevBalance) +
          Number(refreshedBalance);

        updateTotalBalance(String(updatedConnectedBankingTotal));
      } else {
        setRefreshSuccess(false);
        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, errorcode.errorFailed);
      }
    } catch (error) {
      setRefreshSuccess(false);
      CommonToast({
        text: error,
        toast_position,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  const service =
    !services?.includes("VAccountBalance") && !services?.includes("Admin");
  return (
    <div
      className={
        " flex flex-row Qmd:flex-col Qlg:flex-row justify-between items-start relative cursor-pointer  opacity-base-opacity w-full  bg-primary-nav rounded-border-radius-sm py-padding-xs px-padding-sm  z-z-index-base global-hover-white"
      }
      onClick={() => {
        navigate(
          `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${owner?.id}`,
        );
      }}
    >
      <div
        title={owner.bank_acc_no}
        className="border-r-border Qmd:border-r-border-base Qlg:border-r-border border-primary-bg flex flex-col gap-gap-xs min-w-standard-account-min-width pr-padding-md flex-shrink-0"
      >
        <p className="text-text-primary text-font-xs font-normal">
          {" "}
          {owner.bank_acc_no.substring(0, 4) +
            " •••• " +
            owner.bank_acc_no.substring(owner.bank_acc_no.length - 4)}
        </p>
        <p className="text-text-secondary text-font-xxs font-normal">
          Account number
        </p>
      </div>

      <div className="flex w-full justify-end gap-gap-button-s overflow-hidden Qmd:pt-padding-button-s Qlg:pt-padding-base">
        <div className="flex flex-col gap-y-gap-xs text-end Qmd:text-start Qlg:text-end items-end justify-between gap-gap-sm w-width-full ">
          {/* <p
            className={`text-font-xs ${
              owner?.owner_account_balance
                ? owner?.owner_account_balance <
                    GlobalConfiguration?.lengthCheckZero &&
                  !(
                    isNaN(owner.owner_account_balance) ||
                    owner.owner_account_balance === "xxxx.xx" ||
                    owner.owner_account_balance === null ||
                    owner.owner_account_balance === undefined
                  )
                  ? "text-failed font-semibold"
                  : "text-settled font-semibold"
                : "text-text-primary font-normal"
            }`}
          >
            {isNaN(owner.owner_account_balance) ||
            owner.owner_account_balance === "xxxx.xx" ||
            owner.owner_account_balance === null ||
            owner.owner_account_balance === undefined ? (
              "Not available"
            ) : (
              <>
                {"INR " +
                  formatTotalBalance(Number(owner?.owner_account_balance))
                    .amount +
                  " " +
                  formatTotalBalance(Number(owner?.owner_account_balance)).abbr}
              </>
            )}
          </p> */}

          <div className="flex items-center justify-end Qmd:justify-end Qlg:justify-end gap-gap-xs w-width-full Qmd:flex-row-reverse Qlg:flex-row">
            {isLoading && accId === owner?.id ? (
              <img
                src={ICONS?.LOADER_GIF}
                alt=""
                className="h-icon-sm w-icon-sm flex-shrink-0"
              />
            ) : (
              refreshSuccess &&
              accId === owner?.id &&
              !ownerAccBalanceLoading &&
              !ownerAccBalanceError && (
                <>
                  {Number(currentConnectedBal) > Number(prevConnectedBal) ? (
                    <img
                      src={ICONS.ARROW_UP_GREEN_GIF}
                      alt="Increase"
                      className="h-icon-md w-icon-md flex-shrink-0"
                    />
                  ) : Number(currentConnectedBal) < Number(prevConnectedBal) ? (
                    <img
                      src={ICONS.ARROW_DOWN_RED_GIF}
                      alt="Decrease"
                      className="h-icon-sm w-icon-sm flex-shrink-0"
                    />
                  ) : null}
                </>
              )
            )}
            <p
              className={`text-font-xs ${
                owner?.owner_account_balance
                  ? owner?.owner_account_balance <
                    GlobalConfiguration.lengthCheckZero
                    ? "text-failed font-semibold"
                    : "text-settled font-semibold"
                  : "text-text-primary font-normal"
              }`}
            >
              {owner?.owner_account_balance
                ? `
          ${shouldBeRedacted(owner?.owner_account_balance) ? "" : "INR "}
          ${formatTotalBalance(Number(owner?.owner_account_balance)).amount}
          ${formatTotalBalance(Number(owner?.owner_account_balance)).abbr}
        `
                : "Not available"}
            </p>
          </div>
          <p className="text-font-xxs text-text-secondary font-normal flex-1 w-width-full">
            {owner?.owner_account_balance_last_fetched_at_in_words &&
            requiredServices
              ? `Balance - ${owner?.owner_account_balance_last_fetched_at_in_words}`
              : "Balance"}
          </p>
        </div>
        {owner?.connected_banking === "Y" && requiredServices && (
          <div className="my-auto">
            {!service && (
              <CardActionableButton
                btnType="button"
                handleFunction={(e) => {
                  if (
                    services?.includes("VAccountBalance") ||
                    services?.includes("Admin")
                  ) {
                    e.stopPropagation();
                    setAccId(owner?.id);
                    handleRefresh(owner?.id);
                  } else {
                    e.stopPropagation();
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "VAccountBalance,Admin",
                      },
                    });
                  }
                }}
                isDisabled={
                  isLoading ||
                  (!services?.includes("VAccountBalance") &&
                    !services?.includes("Admin"))
                }
                bgColor="var(--primary-card)"
                disabledBgColor="var(--primary-nav-act)"
                icon={ICONS?.RELOAD_REFRESH_WHITE}
                hoverOption="white"
                title="Refresh"
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default OwnerAccountConnectedBankCard;
